import { commercialReference } from '../quoteReference';
import CircularProgress from '../../../shared/components/CircularProgress/CircularProgress';
import React from 'react';

import Box from '../../../shared/components/Box/Box';
import Typography from '../../../shared/components/Typography/Typography';
import QuoteHeader from './QuoteHeader';

const QuoteList = ({
  quotes,
  loading,
  formatMoney,
  getProjectName,
  getQuoteProject,
  canCreate,
  onCreate,
  onOpen,
}) => (
  <>
    <QuoteHeader
      title="Devis"
      subtitle="Liste des devis enregistres et ventilation des frais internes."
      primaryAction={canCreate ? { label: 'Creer un devis', onClick: onCreate } : null}
    />

    <section className="quote-panel">
      {loading ? (
        <Box className="loading-state">
          <CircularProgress />
        </Box>
      ) : quotes.length === 0 ? (
        <Box className="empty-state">
          <Typography variant="body1" color="textSecondary">
            Aucun devis trouve
          </Typography>
        </Box>
      ) : (
        <table className="quote-list-table">
          <thead>
            <tr>
              <th>Numero</th>
              <th>Titre</th>
              <th>Projet</th>
              <th>Statut</th>
              <th>Total client HT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {quotes.map((quote) => {
              const project = getQuoteProject(quote);

              return (
                <tr key={quote.id}>
                  <td data-label="Numero"><strong>{commercialReference(quote.quoteNumber || quote.quote_number, quote.currentVersion?.versionNumber || 1)}</strong></td>
                  <td data-label="Titre">{quote.title}</td>
                  <td data-label="Projet">{getProjectName(project)}</td>
                  <td data-label="Statut"><span className="quote-status">{quote.status}</span></td>
                  <td className="quote-money" data-label="Total client HT">{formatMoney(quote.totalClientAmount || quote.total_client_amount || quote.totalAmount, quote.currentVersion?.currencyCode ?? 'EUR')}</td>
                  <td data-label="Action">
                    <button className="basic-button" type="button" onClick={() => onOpen(quote.id)}>
                      Modifier
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  </>
);

export default QuoteList;
